import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { IWidgetConfigComponent } from "src/app/models/dashboard/dashboard-widget.model";
import { SampleStatusFiltersComponent } from "./sample-status-filters.component";
import {
    SampleStatusFilterValues,
    SAMPLE_STATUS_FILTER_DEFAULTS,
    configToFilterValues,
    filterValuesToConfig,
} from "./sample-status-widget.constants";

@Component({
    standalone: true,
    selector: "app-sample-status-widget-config",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SampleStatusFiltersComponent],
    templateUrl: "./sample-status-widget-config.component.html",
    styleUrls: ["./sample-status-widget-config.component.scss"]
})
export class SampleStatusWidgetConfigComponent
    implements OnInit, IWidgetConfigComponent
{
    @Input() config: Record<string, unknown> = {};
    @Output() configChange = new EventEmitter<Record<string, unknown>>();

    filterValues: SampleStatusFilterValues = {
        ...SAMPLE_STATUS_FILTER_DEFAULTS,
    };

    ngOnInit(): void {
        this.filterValues = configToFilterValues(this.config);
    }

    onFilterChange(values: SampleStatusFilterValues): void {
        this.filterValues = values;
        this.configChange.emit(filterValuesToConfig(values));
    }
}
